import { supabase } from '../../lib/supabaseClient';
import { logActivity } from './filesService';
import type { DossierFile } from './filesService';

/** Liste les fichiers GED liés à une tâche. */
export async function listTaskFiles(taskId: string): Promise<DossierFile[]> {
  const { data, error } = await supabase
    .from('task_files')
    .select('dossier_files(*)')
    .eq('task_id', taskId);
  if (error) throw error;
  return (data ?? [])
    .map((row) => (row as unknown as { dossier_files: DossierFile }).dossier_files)
    .filter((f): f is DossierFile => f != null);
}

/** Lie un fichier du dossier à une tâche. */
export async function linkFile(taskId: string, fileId: string, linkedBy: string): Promise<void> {
  const { error } = await supabase
    .from('task_files')
    .insert({ task_id: taskId, file_id: fileId, linked_by: linkedBy });
  if (error) throw error;

  const { data: file } = await supabase
    .from('dossier_files')
    .select('filename, dossier_id')
    .eq('id', fileId)
    .single();
  if (file) {
    await logActivity({
      action: 'task.file_link',
      dossierId: file.dossier_id,
      subjectType: 'dossier_file',
      subjectId: fileId,
      details: { task_id: taskId, filename: file.filename },
    });
  }
}

/** Détache un fichier d'une tâche (ne supprime pas le fichier GED). */
export async function unlinkFile(taskId: string, fileId: string): Promise<void> {
  const { data: file } = await supabase
    .from('dossier_files')
    .select('filename, dossier_id')
    .eq('id', fileId)
    .single();

  const { error } = await supabase
    .from('task_files')
    .delete()
    .eq('task_id', taskId)
    .eq('file_id', fileId);
  if (error) throw error;

  if (file) {
    await logActivity({
      action: 'task.file_unlink',
      dossierId: file.dossier_id,
      subjectType: 'dossier_file',
      subjectId: fileId,
      details: { task_id: taskId, filename: file.filename },
    });
  }
}
